import actions, { MODAL_TYPES, NAVIGATION_ORIGINS } from 'state/constants';

export const openModal =
  (modalType, meta = {}) =>
  dispatch => {
    dispatch({ type: actions.OPEN_MODAL, payload: modalType, meta });
  };

export const closeModal = () => dispatch => {
  dispatch({ type: actions.CLOSE_MODAL });
};

export const openUpsellModal = () => openModal(MODAL_TYPES.PDP_UPSELL);

export const openPdpUpdateFormModal = () => openModal(MODAL_TYPES.PDP_UPDATE_FORM);

export const openAddToCartModal = () => openModal(MODAL_TYPES.PDP_ADD_TO_CART);

export const openPdpColorwayUpdatesFormModal = () =>
  openModal(MODAL_TYPES.PDP_COLORWAY_UPDATE_FORM);

export const openSizeChartModal = identifier => openModal(identifier);

export const openStoreInventoryModal = () => openModal(MODAL_TYPES.PDP_STORE_INVENTORY);

export const openPdpZoomViewModal = () => openModal(MODAL_TYPES.PDP_ZOOM_VIEW);

export const openGeofencingShopSelectorModal = () =>
  openModal(MODAL_TYPES.GEOFENCING_SHOP_SELECTOR);

export const openStoryCardModal = origination => openModal(MODAL_TYPES.STORY_CARD, { origination });

export const openReturnsPageModal = () => openModal(MODAL_TYPES.RETURNS_PAGE);

export const openHomepageHeroVideoModal = origination =>
  openModal(MODAL_TYPES.HOMEPAGE_HERO_VIDEO, { origination });

export const openLandingPageHeroVideoModal = origination =>
  openModal(MODAL_TYPES.LANDING_PAGE_HERO_VIDEO, { origination });

export const openArticlePageModal = origination =>
  openModal(MODAL_TYPES.ARTICLE_PAGE, { origination });

export const openSustainabilityPageModal = origination =>
  openModal(MODAL_TYPES.SUSTAINABILITY_PAGE, { origination });

export const openPdpStoryModuleModal = origination =>
  openModal(MODAL_TYPES.PDP_STORY_MODULE, { origination });

export const openPdpVideoModal = origination => openModal(MODAL_TYPES.PDP_VIDEO, { origination });

export const openSignupModal = meta => openModal(MODAL_TYPES.SIGNUP_MODAL, meta);

export const openConsentConfirmationModal = decision =>
  openModal(MODAL_TYPES.CONSENT_CONFIRMATION, { decision });

export const trackComponentMount = component => dispatch => {
  dispatch({ type: actions.TRACK_COMPONENT_MOUNT, meta: { component } });
};

export const trackNavigation =
  ({ url, origination }) =>
  dispatch => {
    dispatch({ type: actions.TRACK_NAVIGATION, payload: { url }, meta: { origination } });
  };

export const trackTopNavigationNavigation = url =>
  trackNavigation({ url, origination: NAVIGATION_ORIGINS.TOP_NAVIGATION });

export const trackBreadcrumbNavigation = url =>
  trackNavigation({ url, origination: NAVIGATION_ORIGINS.BREADCRUMB });

export const trackSecondaryNavigationNavigation = url =>
  trackNavigation({ url, origination: NAVIGATION_ORIGINS.SECONDARY_NAVIGATION });

export const trackSearchNavigation = url =>
  trackNavigation({ url, origination: NAVIGATION_ORIGINS.SEARCH });
